import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d9oshlaqs38sj6jc7en0';

export default function AboutPage() {

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫画网',
    url: 'https://www.hanmanhua.com',
    description: '韩漫画网精选好看的韩国漫画供您韩漫在线免费阅读，同时提供高清韩漫大全，画质清晰带来视觉上的享受',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@hanmanhua.com',
      availableLanguage: ['Chinese'],
    },
  };

  const stats = [
    { value: '5000+', label: '漫画资源' },
    { value: '120万+', label: '注册用户' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.8', label: '用户评分' },
  ];

  const reviews = [
    {
      name: '漫画爱好者小陈',
      content: '韩漫画网的画质真的太清晰了！比我在其他网站看的好太多了，而且更新速度很快，追更体验满分。',
      rating: 5,
    },
    {
      name: '二次元少女',
      content: '超喜欢这里的分类功能，一下子就找到了好多好看的恋爱甜宠漫画。每天都要上来刷更新！',
      rating: 5,
    },
    {
      name: '韩漫忠实粉丝',
      content: '资源非常齐全，很多冷门的韩国漫画都能在这里找到。推荐给了好多朋友，都说好用。',
      rating: 5,
    },
    {
      name: '阅读达人小王',
      content: '页面设计简洁大气，阅读体验很流畅，没有乱七八糟的弹窗广告。支持韩漫画网做得更好！',
      rating: 4,
    },
  ];

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mt-6">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              关于韩漫画网
            </h1>
            <p className="text-sm text-foreground-500 mt-2 max-w-3xl">
              韩漫画网是一个专注于<strong>好看的韩国漫画</strong>在线免费阅读的专业平台，致力于为广大漫画爱好者提供
              <strong>高清韩漫大全</strong>，让每一位用户都能享受<strong>韩漫在线免费阅读</strong>带来的视觉盛宴。
            </p>
          </section>

          <section className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-5 rounded-lg bg-background-100"
              >
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500">{stat.value}</p>
                <p className="text-sm text-foreground-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </section>

          <section className="mt-12 md:mt-16">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">
              我们的使命
            </h2>
            <p className="text-sm text-foreground-500 text-center max-w-2xl mx-auto mb-8">
              让每一位漫画爱好者都能便捷地找到并阅读自己喜欢的韩国漫画
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-6 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-100/80 flex items-center justify-center mb-3">
                  <i className="ri-image-line text-xl text-primary-500 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">高清画质</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有漫画均经过专业优化处理，确保高清韩漫大全的画质清晰度，让每一页画面的细节都栩栩如生。
                </p>
              </div>

              <div className="p-6 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-accent-100/80 flex items-center justify-center mb-3">
                  <i className="ri-time-line text-xl text-accent-600 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">极速更新</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  与韩国版权方保持紧密合作，热门连载漫画同步更新，让韩漫在线免费阅读的追更体验快人一步。
                </p>
              </div>

              <div className="p-6 rounded-lg bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100/80 flex items-center justify-center mb-3">
                  <i className="ri-shield-check-line text-xl text-secondary-600 w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">完全免费</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  韩漫画网始终坚持免费阅读理念，让所有用户都能无门槛畅享好看的韩国漫画，没有任何隐藏收费。
                </p>
              </div>
            </div>
          </section>

          <section className="mt-12 md:mt-16">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">
              用户口碑
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8">听听用户们怎么说</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {reviews.map((review) => (
                <div key={review.name} className="p-5 rounded-lg bg-background-100">
                  <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i
                        key={i}
                        className={`text-sm w-4 h-4 flex items-center justify-center ${
                          i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">{review.content}</p>
                  <p className="text-xs text-foreground-500">{review.name}</p>
                </div>
              ))}
            </div>
          </section>

          <section id="contact" className="mt-12 md:mt-16">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8">
              有任何问题或建议，欢迎与我们联系
            </p>

            <div className="max-w-[600px] mx-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
                  <div className="w-10 h-10 rounded-full bg-primary-100/80 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-lg text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">电子邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">contact@hanmanhua.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100">
                  <div className="w-10 h-10 rounded-full bg-accent-100/80 flex items-center justify-center shrink-0">
                    <i className="ri-customer-service-line text-lg text-accent-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">客服热线</p>
                    <p className="text-sm font-medium text-foreground-800">400-888-韩漫</p>
                  </div>
                </div>
              </div>

              <form
                  action={CONTACT_FORM_URL}
                  method="POST"
                  encType="application/x-www-form-urlencoded"
                  data-readdy-form
                  id="contact-form"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    const honeypotVal = (formData.get('phone_alt') as string || '').trim();
                    if (honeypotVal) {
                      alert('提交成功，我们会尽快回复您！');
                      form.reset();
                      return;
                    }
                    formData.delete('phone_alt');
                    const urlEncoded = new URLSearchParams();
                    formData.forEach((value, key) => {
                      urlEncoded.append(key, value as string);
                    });
                    try {
                      const res = await fetch(CONTACT_FORM_URL, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: urlEncoded.toString(),
                      });
                      const responseText = await res.text();
                      let parsed: any = {};
                      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
                      if (res.ok && parsed?.code === 'OK') {
                        alert('提交成功，我们会尽快回复您！');
                        form.reset();
                      } else {
                        const errMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
                        alert(errMsg);
                      }
                    } catch {
                      alert('网络错误，请稍后重试');
                    }
                  }}
                  className="space-y-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                        placeholder="您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                        placeholder="your@email.com"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                    <input
                      id="contact-subject"
                      name="subject"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                      placeholder="请输入您的留言（最多500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1">最多500字</p>
                  </div>
                  <div className="website-alt-wrap">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <button
                    type="submit"
                    className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 whitespace-nowrap"
                  >
                    发送留言
                  </button>
                </form>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}